var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChartOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#636E95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.167 2.333C14.522 2.333 14 2.856 14 3.5v9.333c0 .645.522 1.167 1.167 1.167H24.5c.644 0 1.167-.522 1.167-1.167 0-5.799-4.701-10.5-10.5-10.5zm1.166 9.334V4.748c3.586.517 6.402 3.333 6.919 6.919h-6.919z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29 16.403c-.607-.217-1.274.1-1.491.706l-.002.006c-1.72 4.86-7.052 7.405-11.912 5.686-4.86-1.719-7.405-7.052-5.686-11.911.94-2.657 3.03-4.747 5.686-5.687.609-.212.93-.878.717-1.487-.212-.61-.878-.93-1.487-.718C4.04 5.145.855 11.81 3.001 17.885c2.146 6.075 8.811 9.26 14.887 7.114 3.324-1.174 5.94-3.79 7.114-7.114.21-.606-.108-1.267-.712-1.482z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartOutline);
export default __webpack_public_path__ + "static/media/pie-chart-outline.ec96f7a7202bb97032463b6f129c34d3.svg";
export { ForwardRef as ReactComponent };